// ** Initial State
const initialState = {
  projectMemberDropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedUser: null
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PROJECT_MEMBERS_DROPDOWN':
      return { ...state, projectMemberDropdown: action.data }
    case 'GET_ALL_USERS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_USERS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_USER':
      return { ...state, selectedUser: action.selectedUser }
    case 'ADD_USER':
      return { ...state }
    case 'DELETE_USER':
      return { ...state }
    default:
      return { ...state }
  }
}
export default users
